<template>
    <vBankAccountComponent :postList="postList" v-if="flag"></vBankAccountComponent>
</template>
<script>
import vBankAccountComponent from '../../listComponent/basicdata/bankAccount/bankAccountComponent.vue';
export default {
    name: 'bankAccount',
    components: {
        vBankAccountComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                rel_type: true,
                rel_rid: true,
                account_name: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>